module.exports = __webpack_public_path__ + "img/clear.404b6a90.svg";